import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-white shadow-md">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center flex-col md:flex-row">
        <div className="mb-4 md:mb-0 flex flex-col md:flex-row items-center">
          <a
            href="https://www.buymeacoffee.com/rukywe"
            target="_blank"
            rel="noopener noreferrer"
            className="mb-2 md:mb-0 md:mr-4"
          >
            <img
              src="https://img.buymeacoffee.com/button-api/?text=Buy me a coffee&emoji=&slug=rukywe&button_colour=9333EA&font_colour=ffffff&font_family=Cookie&outline_colour=000000&coffee_colour=FFDD00"
              alt="Buy Me a Coffee"
            />
          </a>
          <a
            href="mailto:ranigboro@gmail.com"
            className="text-gray-800 hover:text-purple-500 transition duration-300"
          >
            Contact Me
          </a>
        </div>
        <p className="text-gray-700 text-sm text-center">
          © {new Date().getFullYear()} ChowBuddy. All rights reserved. Made with
          ❤️ by Rukywe.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
